var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.displayType") } },
    [
      _c(
        "el-select",
        {
          model: {
            value: _vm.optionModel.type,
            callback: function ($$v) {
              _vm.$set(_vm.optionModel, "type", $$v)
            },
            expression: "optionModel.type",
          },
        },
        [
          _c("el-option", {
            attrs: { label: "daterange", value: "daterange" },
          }),
          _vm._v(" "),
          _c("el-option", {
            attrs: { label: "datetimerange", value: "datetimerange" },
          }),
          _vm._v(" "),
          _c("el-option", {
            attrs: { label: "monthrange", value: "monthrange" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }